export { Footer } from "./Footer";
export type { FooterProps, MobileDesktopVisibility } from "./Footer";
